import { $authHost } from '.'
import { Token, User } from '../helpers/types/user'

export const login = async (username: string, password: string) => {
	const { data } = await $authHost.post('/auth/login', {
		username,
		password
	})
	return data as Token
}

export const refresh = async () => {
	const { data } = await $authHost.get('/auth/refresh', {
		withCredentials: true
	})
	return data as User
}

export const userinfo = async () => {
	const { data } = await $authHost.get('/auth/userinfo', {
		withCredentials: true
	})
	return data as User
}

export const logout = async () => {
	const { data } = await $authHost.delete('/auth/logout', {
		withCredentials: true
	})
	return data as User
}

export const changePassword = async (
	oldPassword: string,
	newPassword: string
) => {
	const { data } = await $authHost.post('/auth/change-password', {
		oldPassword,
		newPassword
	})
	return data
}
